import React from 'react';
import { Card, Header, Icon, Label, Modal, Transition } from 'semantic-ui-react';
import { Fecha } from 'src/componentes';
import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';
import { TarjetaPropsComunes } from './tipos';

interface Props extends Omit<TarjetaPropsComunes, 'fechaAdicional' | 'observaciones'> {
    readonly titulo: React.ReactNode;
    readonly observaciones: React.ReactNode;
    readonly elevado?: boolean;
    readonly mensajeExtra?: React.ReactNode | false;
    readonly eliminable?: boolean;
    readonly numeroDeCuota?: number;
}

interface State {
    readonly mostrandoBotonEliminar: boolean;
    readonly mostrandoConfirmacion: boolean;
}

class TarjetaObservacion extends React.Component<Props, State> {
    public state: State = {
        mostrandoBotonEliminar: false,
        mostrandoConfirmacion: false,
    };

    public render() {
        const {
            elevado,
            fechaDeRegistro,
            mensajeExtra,
            nombreDelUsuario,
            observaciones,
            titulo,
            numeroDeCuota,
        } = this.props;

        const { mostrandoBotonEliminar } = this.state;

        // Estos props no se pueden pasar manualmente, pero semantic-ui sí podría pasarlos
        // en determinadas circunstancias, como por ejemplo en las animaciones.
        // tslint:disable-next-line: no-any
        const { className, style } = this.props as any;
        return (
            <Card
                fluid
                raised={elevado}
                className={className}
                style={style}
                onMouseOver={() => this.setState({ mostrandoBotonEliminar: true })}
                onMouseLeave={() => this.setState({ mostrandoBotonEliminar: false })}
            >
                <Card.Content>
                    <Transition visible={mostrandoBotonEliminar} duration={150}>
                        <Label
                            as='a'
                            floating
                            color='red'
                            onClick={() => this.setState({ mostrandoConfirmacion: true })}
                        >
                            <Icon name='trash' style={{ margin: '0' }} />
                        </Label>
                    </Transition>

                    {this.renderizarModalConfirmacion()}

                    <Header floated='right' as='h4'>
                        <Fecha fecha={fechaDeRegistro} />
                    </Header>

                    <Card.Header>
                        {titulo}
                        {numeroDeCuota !== undefined ? `, para la cuota ${numeroDeCuota}` : false}
                    </Card.Header>
                    <Card.Meta content={nombreDelUsuario} />
                    <Card.Description>{observaciones}</Card.Description>
                </Card.Content>
                {!!mensajeExtra && <Card.Content extra>{mensajeExtra}</Card.Content>}
            </Card>
        );
    }

    private renderizarModalConfirmacion() {
        const { mostrandoConfirmacion } = this.state;

        const cerrar = () => this.setState({ mostrandoConfirmacion: false });

        return (
            <ModalEnfocable open={mostrandoConfirmacion} onClose={cerrar}>
                <Modal.Header>¿Está seguro que desea eliminar este comentario?</Modal.Header>
                <Modal.Content>Esta acción no se puede deshacer.</Modal.Content>
                <Modal.Actions
                    actions={[
                        { key: 'no', content: 'No, volver', onClick: cerrar },
                        {
                            key: 'si',
                            content: 'Sí, eliminar',
                            negative: true,
                            onClick: this.eliminarComentario,
                        },
                    ]}
                />
            </ModalEnfocable>
        );
    }

    private readonly eliminarComentario = () => {
        const { alEliminar } = this.props;
        alEliminar();
        this.setState({ mostrandoConfirmacion: false });
    };
}

export default TarjetaObservacion;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Observaciones/TarjetaObservacion.tsx